'use strict';
var escalationIssueTrackingModalTpl = require('../../../escalation/issueTrackingModal.html');
var util = require('../../../util/property-util');
var arrayUtil = require('../../../util/array-util');
var zabbixUtil = require('./zabbix-util');

module.exports = /*@ngInject*/ ["$rootScope", "$scope", "ProjectService", "$stateParams", "ZabbixIssueFactory", "ZabbixOverviewFactory", "$filter", "NgTableParams", "$timeout", "$uibModal", "UrlRoutingFactory", "MonitoringStoreService", "ConfigurationStoreService", "GoogleMapsFactory",
 function AlarmMonitoringPageController($rootScope, $scope, ProjectService, $stateParams, ZabbixIssueFactory, ZabbixOverviewFactory, $filter, NgTableParams, $timeout, $uibModal, UrlRoutingFactory, MonitoringStoreService, ConfigurationStoreService, GoogleMapsFactory) {
     var vm = this;

     var projectConfiguration = ConfigurationStoreService.getProjectConfiguration( ProjectService.getSelectedProjectId());

     vm.deviceCollection = undefined;
     vm.tree = undefined;
     vm.ackAllTriggered = false;
     vm.ackAllIsSuccessful = undefined;
     vm.ackSubmissionLoading = false;
     vm.devicePropertyVisibilityConfigurations = (projectConfiguration && projectConfiguration.devicePropertyVisibilityConfigurations);
     vm.hideTrainTreeContextMenu = projectConfiguration && projectConfiguration.trainTreeStructure ? projectConfiguration.trainTreeStructure.hideContextMenu : false;
     var name = 'alarm';
     var trainId = $stateParams.trainId;
     var projectId = $stateParams.projectId;
     var eventId = UrlRoutingFactory.get('eventId');
     var trainFleet = null;
     var currentHashCode;

     var currentIssues = [];
     var allIssues = [];

     var interval;

     vm.trainAlarms;
     vm.trainOfficialId;

     init();

     /*
      FUNCTIONS
      */

     function init() {
         $scope.$emit('init-child', name);
         vm.selectedProject = ProjectService.getSelectedProjectId();
         var currentTrain = MonitoringStoreService.getTrainByTrainId(projectId, trainId);
         getTrainsData([currentTrain]);
     }

     $scope.$watch('currentTrain', updateTrainAsset);

     $rootScope.$on('current-train-updated', function (ev, train) {
         vm.currentTrain = train;
         getTrainsData([vm.currentTrain])
         if (vm.currentTrain.structure) {
            createCanvasDataSet(vm.currentTrain.structure[0] || vm.currentTrain.structure);
        }
     });

     function updateTrainAsset() {
        preprocessTrainData();
        if (vm.currentTrain.structure) {
            createCanvasDataSet(vm.currentTrain.structure[0] || vm.currentTrain.structure);
        }
     } 

     function preprocessTrainData() {
        vm.currentTrain = JSON.parse(vm.currentTrain);
        getTrainsData([vm.currentTrain]);
        var customZabbixConfigObject = vm.currentTrain.customZabbixConfig;
        vm.trainOfficialId = customZabbixConfigObject ? customZabbixConfigObject.officialId : undefined;
        trainFleet = customZabbixConfigObject ? customZabbixConfigObject.type : '';

        if (vm.currentTrain.structure) {
        vm.currentTrain.structure = handleNewStructure(vm.currentTrain.structure, vm.trainOfficialId);
            if (util.isDefined(eventId)) {
                var issue = arrayUtil.getFirstInList(allIssues, 'eventId', eventId);
                vm.onRaiseIncidentClick(issue);
                eventId = undefined;
                UrlRoutingFactory.delete('eventId');
            }
            ZabbixOverviewFactory.customizeTreeStructure( vm.currentTrain.structure[0] || vm.currentTrain.structure, vm.currentTrain.customZabbixConfig);
        }

        var trainTypeConfig = vm.currentTrain && vm.currentTrain.trainTypeConfiguration;
        var deviceConfigurations = trainTypeConfig && trainTypeConfig.dynamicConsistConfig &&  trainTypeConfig.dynamicConsistConfig.deviceConfigurations;
        
        if (deviceConfigurations && vm.currentTrain && vm.currentTrain.structure && vm.currentTrain.structure.deviceGroups) {
            vm.currentTrain.structure.deviceGroups = vm.currentTrain.structure.deviceGroups.map((deviceGroup) => {
               deviceGroup.devices.map((device) => {
                  var deviceConfig = deviceConfigurations && device.type ? deviceConfigurations.find(conf => conf.type.toLowerCase() === device.type.toLowerCase()) : null;
                  if(deviceConfig && deviceConfig.remapIPto) {
                      if (isNormalInteger(deviceConfig.remapIPto)) {
                        device.surfIPAddress = device.ipAddr + ":" + deviceConfig.remapIPto;
                      }
                      else {
                        var ipRemappingPort = deviceConfig.ipRemappingPort;
                        var targetDevice = vm.currentTrain.structure.allDevices.find(target => target.type === deviceConfig.remapIPto);
                        device.surfIPAddress = targetDevice.ipAddr;
                        if (ipRemappingPort) {
                            device.surfIPAddress += ':' + (ipRemappingPort + device.deviceId).toString();
                        }
                      }
                  }
                  return device
              })
              return deviceGroup;
          })
        }
    }

    function isNormalInteger(str) {
        var n = Math.floor(Number(str));
        return n !== Infinity && String(n) === str && n >= 0;
    }

     function createCanvasDataSet(trainStructure) {
         vm.canvasData = {};
         vm.canvasData.train = trainStructure;
         vm.canvasData.trainConsists = vm.currentTrain && vm.currentTrain.trainConsists;
         vm.canvasData.trainConsistView = vm.currentTrain && vm.currentTrain.trainConsistView;
         vm.canvasData.dynamicConsist = vm.currentTrain && vm.currentTrain.dynamicConsist;
        }

     $scope.$on('de-activate-' + name, function () {
         $timeout.cancel(interval);
         alertClick();
     });

     function changeCoachNames(trainStruct) {
         if (vm.currentTrain && vm.currentTrain.coachNames && vm.currentTrain.coachNames.length > 0) {
             // console.log(coachNames);

             trainStruct[0].deviceGroups.forEach(function (deviceGroup, i) {
                 // console.log(deviceGroup.name);
                 deviceGroup.name = vm.currentTrain.coachNames[i];
                 // console.log({deviceAfter: deviceGroup.name});
             });
         }
         return trainStruct;
     }

    function getIncidents(curIssues){

        if(vm.currentTrain && vm.currentTrain.incidents) {
            var incidents = vm.currentTrain ? vm.currentTrain.incidents : [];
            for (var issue = 0; issue < curIssues.length; issue++){
                for (var incident = 0; incident < incidents.length; incident++){
                    if (curIssues[issue].eventId.toString() === incidents[incident].alarmId){
                        curIssues[issue].incidentId = incidents[incident].incidentId;
                    }
                }
            }
        }
        return curIssues;
    }

     function handleNewStructure(data, trainOfficialId) {
         var coachData = changeCoachNames([data]);
         var hashStructure = ZabbixOverviewFactory.fillHashCodes(coachData);
         var newStructure = ZabbixOverviewFactory.fillPriorities(hashStructure);

         var structure;
         var reloadData = false;
         if (!util.isDefined(vm.tree)) {
             structure = newStructure;
         } else {
             structure = ZabbixOverviewFactory.reloadOldStructure(vm.tree, newStructure);
             reloadData = true;
         }
         vm.tree = structure;
         allIssues = vm.currentTrain.issues;
         vm.tree[0].issues = allIssues;

         if (!reloadData) {
             $timeout(function () {
                 $scope.$broadcast('click-element', structure);

                 structure.deviceGroups.forEach(function (deviceGroup) {
                     $scope.$broadcast('click-element', deviceGroup);
                 });
             });
         }


         if (!(reloadData && vm.selectedHashCode)) {
            currentIssues =  getIncidents(allIssues);       
   
            vm.trainAlarms = currentIssues;
   
            if (structure.length > 0) {
                structure = structure[0];
            } else {
                structure = undefined;
            }
         } else {
            currentIssues =  getIncidents(allIssues);
            vm.trainAlarms = currentIssues;
         }
         return structure;
     }


     function extractEventIds(issues, type) {
        var issuesByCurrentType = issues.filter(function (issue) {
            return issue.type === type;
        });
        var eventIds = issuesByCurrentType.map(function(issue) {
           return issue.eventId;
        }).filter(function(issueEventId) {
            return !!issueEventId;
        });

        return eventIds;
     }

     vm.filteredDeviceName = function (deviceName) {
         return zabbixUtil.stripProjectAndTrain(deviceName);
     };

     vm.filteredDescription = function (description, hostname, filteredname) {
         return description.replace(hostname, filteredname);
     };

     vm.getColor = function (level) {
         return zabbixUtil.getPriorityColor(level);
     };

     vm.getAlarmAckColor = function (level, issue) {
        return zabbixUtil.getAlarmAckColor(level, [issue]);
    };

    vm.hasAlarmToAck = function(issues) {
        var allAlarmAcknowledged = issues && issues.reduce(function (allAcknowledged, currentIssue) {
            return allAcknowledged && currentIssue.acknowledged;
        }, true);
        return !allAlarmAcknowledged;
    };

    vm.onSelect = function($event) {
        vm.selectedHashCode  = $event && $event.item && $event.item.hashCode;
        var object = {
            data: $event.item.data,
            level: $event.item.type,
            opened: true
        };
        $scope.$emit('clicked-element', object, true);
        $scope.$apply();
    }

    vm.onRaiseIncidentClick = function(alarm) {

        alarm.fleet = trainFleet;

        var issueTrackingModal = $uibModal.open({
            template: escalationIssueTrackingModalTpl,
            controller: 'IssueTrackingModalController',
            controllerAs: 'vm',
            keyboard: true,
            animation: true,
            resolve: {
                issue: alarm
            }
        });

        // on modal close/dismiss
        issueTrackingModal.result.then(function (data) {  // Success - on modal close()

            if (util.isTrue(data.success)) {

                // if the issue hasn't been acknowledged yet, fire the ack request!
                if (!alarm.acknowledged) {
                    var eventIds = [];
                    eventIds.push(alarm.eventId);

                    // zabbix-alarm or noc-alarm
                    if (util.isDefined(alarm.type)) {

                        ZabbixOverviewFactory.postAcknowledgement(ProjectService.getSelectedProjectId(), alarm.trainId, eventIds, alarm.type).then(function () {
                            MonitoringStoreService.updateTrainAlarms(alarm.trainId, alarm);
                        });
                    }
                }

                // updating incidentId in alarm List 
                alarm.incidentId = data.incidentId;
            }
        }, function() { /** Cancel - on modal dismiss() */ });

    };

     vm.acknowledgeAllAlarms = function () {


         var types = ['noc-alarm', 'zabbix-alarm'];

         var issuesToAck = currentIssues.filter(function(issue) { // only ACK the ones that are not ack yet
             return !issue.acknowledged;
         });

         vm.ackSubmissionLoading = true;
         var promises = types.map(type => {
            var eventIds = extractEventIds(issuesToAck, type)
            .filter(function(id) { // do not ACK the one with eventId equals -1
                return id !== -1;
            });
            if (eventIds.length === 0) {
            return;
            }
            return ZabbixOverviewFactory.postAcknowledgement(ProjectService.getSelectedProjectId(), trainId, eventIds, type)
         })

         Promise.all(promises).then(() => {
            vm.ackAllTriggered = true;
            vm.ackAllIsSuccessful = true;
            vm.ackSubmissionLoading = false;
             issuesToAck.forEach(function(alarm) {
                 MonitoringStoreService.updateTrainAlarms(trainId, alarm);
             });
         }).catch(() => {
            vm.ackAllTriggered = true;
            vm.ackAllIsSuccessful = false;
            vm.ackSubmissionLoading = false;
         })

     };

     $scope.$on('clicked-element', function (event, data, updateAlarmList) {
         console.log(data)
         console.log(updateAlarmList)

         var issues = ZabbixIssueFactory.findIssues(data.data, data.level);

         if (data.level === 'deviceGroup' && !data.opened) { //Closing a coach will show the tickets for the entire train
             issues = ZabbixIssueFactory.findIssues(vm.currentTrain.structure, 'train');
             data.data = vm.currentTrain.structure;
             data.opened = true;
             data.level = 'train';
         }

         currentHashCode = ZabbixIssueFactory.calculateCurrentHashCode(data.data, data.opened, data.level);
         currentIssues = ZabbixIssueFactory.calculateCurrentIssues(issues, data.opened, data.level, allIssues);

         /*console.log(currentIssues)
         if(vm.trainOfficialId) {
            currentIssues = currentIssues.map(function(issue) {
                issue.trainOfficialId = vm.trainOfficialId;
                return issue;
             });
         }         

         console.log(currentHashCode)
         console.log(vm.selectedHashCode)
         if (currentHashCode && currentHashCode !== vm.selectedHashCode) {
            vm.selectedHashCode = currentHashCode;
         } else {
             vm.selectedHashCode = '';
             currentIssues = allIssues.map(function(issue) {
                issue.trainOfficialId = vm.trainOfficialId;
                return issue;
             });
         }*/

         if (updateAlarmList) {
            vm.trainAlarms = [...currentIssues];
            console.log(vm.trainAlarms)
         }

         $scope.$apply();

     });

     var alertClick = $scope.$on('alert-click', function (event, alert) {
         var device = alert.device;
         if (util.isDefined(device)) {
             $scope.$broadcast('click-element', device);
         }
     });


     $scope.$on('$destroy', function () {
         $timeout.cancel(interval);
         alertClick();
     });

     $scope.$on('canvas-clicked', function (event, localPos) {
         console.log('canvas clicked')
        var deviceDescriptions = vm.deviceCollection.deviceDescriptions;
         var target = vm.deviceCollection.findTarget(localPos);

         if (util.isDefined(target)) {
             //console.log('Clicked on target: ' + target.id);
             currentHashCode = deviceDescriptions.calculateHashCode(target.id, target.coachId);
             currentIssues = deviceDescriptions.getIssues(target.id, target.coachId);
             if (currentHashCode && currentHashCode !== vm.selectedHashCode) {
                vm.selectedHashCode = currentHashCode;
             } else {
                 vm.selectedHashCode = '';
                 currentIssues = allIssues; 
             }
         } else {
             currentHashCode = deviceDescriptions.calculateHashCode('ALL', target && target.coachId); // train level.
             currentIssues = allIssues;   // all issues from the train.
             vm.selectedHashCode = '';
         }

         if (vm.trainOfficialId) {
             currentIssues = currentIssues.map(function (issue) {
                 issue.trainOfficialId = vm.trainOfficialId;
                 return issue;
             });
         }

         vm.trainAlarms = currentIssues;
         $scope.$apply();

     });

     //TODO code to be refined and reviewed 
    var hasFitBounds = false;
    function getTrainsData(tmpTrainData) {

        vm.markers = preprocessTrainsForMapDisplay(tmpTrainData);
        if (vm.map && vm.markers && vm.markers.length > 0 ) {
            vm.map.panTo(vm.bounds.getCenter());
            vm.map.setZoom(12);
            hasFitBounds = true;
        }
        vm.map && vm.map.set('disableDoubleClickZoom', true);
    
    }




    function preprocessTrainsForMapDisplay(trains) {

        if(vm.markers) {
            vm.markers.forEach(function(marker) {
                marker.setMap(null);
            });
        }
        vm.bounds =  new google.maps.LatLngBounds();
        return trains.map(function(train){
            var trainPosition = train.currentPosition;
            if (trainPosition && (trainPosition.latitude !== 0) && (trainPosition.longitude !== 0)) {
                var markerColor = train.alarmAckStyle['background-color'];
                var fontColor = train.alarmAckStyle['color'];
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(trainPosition.latitude, trainPosition.longitude),
                    map: vm.map,
                    title: 'Train: ' + train.name,
                    icon: new google.maps.MarkerImage(
                        zabbixUtil.createCustomMarker(markerColor, fontColor, train.name),
                        new google.maps.Size(32, 42),
                        null,
                        null,
                        new google.maps.Size(32, 42)
                    )
                });
                marker.trainId = train.trainId;
                marker.officialId = Number(train.officialId);
                vm.bounds.extend(marker.getPosition());
                google.maps.event.addListener(marker, 'mouseover', function () {
                    $scope.$emit('information-tooltip');
                });
                return marker;
            } else {
                return null;
            }
        }).filter(function(marker) {
            return !!marker;
        });

    }

 }];
